import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Grid, Tab, Tabs } from '@material-ui/core';
import { TabContext, TabPanel } from '@material-ui/lab';

import noSubscribedStyle from './styles';
import HowAccumulate from './Tabs/HowAccumulate';
import WhatRedeem from './Tabs/WhatRedeem';
import Categories from './Tabs/Categories';

import {
  legalRPGOBank,
  termsRPGOBank,
} from '../../../../../../../config/paths';
import { getBankBenefits } from '../../../../../../../redux/actions/BankActions';

const NoSubscribedBody = (props) => {
  const { mobile } = props;
  const [value, setValue] = React.useState('1');
  const { benefits, benefitsStatus } = useSelector(
    (state) => state.bankReducer,
  );
  const classes = noSubscribedStyle();
  const dispatch = useDispatch();

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (benefitsStatus !== 'succeded') dispatch(getBankBenefits());
  }, []);

  return (
    <Box className={classes.noSubscribedSBody}>
      <TabContext value={value}>
        <Tabs
          value={value}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          variant={mobile ? 'scrollable' : 'fullWidth'}
          scrollButtons="auto"
          centered={!mobile}
        >
          <Tab value="1" label="¿Cómo acumular?" data-cy={'tabHowAccumulate'} />
          <Tab
            value="2"
            label="¿Qué canjear?"
            data-cy={'tabExchangeProducts'}
          />
          <Tab
            value="3"
            label="Categoría Gold & Silver"
            data-cy={'tabCategories'}
          />
        </Tabs>
        <div>
          <TabPanel value="1">
            <HowAccumulate mobile={mobile} />
          </TabPanel>
          <TabPanel value="2">
            <WhatRedeem mobile={mobile} />
          </TabPanel>
          <TabPanel value="3">
            <Categories mobile={mobile} benefits={benefits} />
          </TabPanel>
        </div>
        <Grid container className={classes.gridTerm}>
          <Grid xs={6} className={classes.gridTermLeft}>
            <b>
              <a
                href={termsRPGOBank}
                target="_blank"
                rel="noreferrer"
                data-cy="TermsLinkNoSubscribed"
              >
                Términos y Condiciones
              </a>
              <br />
              <span className={classes.dateValid}>
                *Desde el 06 / 02 / 2021
              </span>
            </b>
          </Grid>
          <Grid xs={6} className={classes.gridTermRight}>
            <b>
              <a
                href={legalRPGOBank}
                target="_blank"
                rel="noreferrer"
                data-cy="LegalLinkNoSubscribed"
              >
                Bases Promocionales
              </a>
              <br />
              <span className={classes.dateValid}>
                *Desde el 06 / 02 / 2021
              </span>
            </b>
          </Grid>
        </Grid>
      </TabContext>
    </Box>
  );
};

NoSubscribedBody.propTypes = {
  mobile: PropTypes.bool,
};

export default NoSubscribedBody;
